import { Model as r } from "../../model.js";
class c extends r {
  constructor(t, o, i) {
    super(), this.profile = t, this.activity = o, this.configuration = i;
  }
}
export {
  c as CustomerModel
};
//# sourceMappingURL=customer.model.js.map
